"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const sanitize_html_1 = __importDefault(require("sanitize-html"));
const react_intl_1 = require("react-intl");
const withoutShortcodeWrapper = (content, tagName) => {
    let result = content;
    result = content.replace(`[${tagName}]`, '');
    result = result.replace(`[/${tagName}]`, '');
    return result;
};
const shortcodeMatcher = (tagName) => new RegExp(`\\[${tagName}\\](.+?)\\[/${tagName}\\]`, 'ig');
const withoutBreaks = (content) => {
    let result = content;
    result = result.replace(new RegExp('<br>', 'ig'), '');
    result = result.replace(new RegExp('<br/>', 'ig'), '');
    result = result.replace(new RegExp('<br />', 'ig'), '');
    return result;
};
const replacedWithDiv = (content, tagName, className, prepend = '') => {
    let result = content;
    result = withoutShortcodeWrapper(result, tagName);
    return `<div class="magazine-${className}">${prepend}${result}</div>`;
};
const replacedWithLink = (content, tagName, link) => {
    let result = content;
    result = withoutShortcodeWrapper(result, tagName);
    return `<a href="${link}" class="magazine-${tagName}">${result}</a>`;
};
const addImageSource = (input) => {
    const result = input.replace(/\/storage\/uploads\/original\//g, `${process.env.CMS_URL}/storage/uploads/body/`);
    return result;
};
const addImageCaptions = (input) => {
    const replacer = match => {
        const hasDescription = match.includes('alt=');
        if (hasDescription) {
            const altTextMatch = match.match(/alt="(.[^"]+)"/g);
            if (altTextMatch) {
                const altText = altTextMatch[0].slice(5, -1);
                return `${match}<div class="imageCaption"><small>${altText}</small></div>`;
            }
            return match;
        }
        return match;
    };
    const result = input.replace(/(<\s*\/?\s*)img(\s*([^>]*)?\s*>)/gi, replacer);
    return result;
};
const addRetinaImages = (input) => {
    const replacer = match => {
        const srcOriginal = match.match(/src="(.[^"]+)"/g)[0].slice(5, -1);
        const srcRetina = srcOriginal.replace('/body/', '/body_2x/');
        const result = match.replace('/>', `srcset="${srcOriginal} 1x, ${srcRetina} 2x" />`);
        return result;
    };
    const result = input.replace(/(<\s*\/?\s*)img(\s*([^>]*)?\s*>)/gi, replacer);
    return result;
};
const processOfferShortcodes = (input) => {
    let result = input;
    const matches = result.match(shortcodeMatcher('offer'));
    if (matches) {
        result = result.replace(shortcodeMatcher('offer'), content => {
            let instanceResult = content;
            instanceResult = instanceResult.replace(shortcodeMatcher('offer'), instanceContent => replacedWithDiv(instanceContent, 'offer', 'widget'));
            instanceResult = withoutBreaks(instanceResult);
            const link = withoutShortcodeWrapper(instanceResult.match(shortcodeMatcher('link'))[0], 'link');
            instanceResult = instanceResult.replace(shortcodeMatcher('link'), '');
            instanceResult = instanceResult.replace(shortcodeMatcher('title'), instanceContent => replacedWithLink(instanceContent, 'title', link));
            instanceResult = instanceResult.replace(shortcodeMatcher('info'), instanceContent => replacedWithDiv(instanceContent, 'info', 'info'));
            return instanceResult;
        });
    }
    return result;
};
const processArticlesShortcodes = (input) => {
    const intl = (0, react_intl_1.useIntl)();
    let result = input;
    const matches = result.match(shortcodeMatcher('articles'));
    if (matches) {
        result = result.replace(shortcodeMatcher('articles'), content => {
            let instanceResult = content;
            instanceResult = instanceResult.replace(shortcodeMatcher('articles'), instanceContent => replacedWithDiv(instanceContent, 'articles', 'widget', `<div class="magazine-widget-headline">${intl.formatMessage({
                id: 'magazine.other_articles_headline',
            })}</div>`));
            instanceResult = withoutBreaks(instanceResult);
            instanceResult = instanceResult.replace(shortcodeMatcher('article'), innerInstanceContent => {
                let innerInstanceResult = innerInstanceContent;
                innerInstanceResult = innerInstanceResult.replace(shortcodeMatcher('article'), item => replacedWithDiv(item, 'article', 'article'));
                const link = withoutShortcodeWrapper(innerInstanceResult.match(shortcodeMatcher('link'))[0], 'link');
                innerInstanceResult = innerInstanceResult.replace(shortcodeMatcher('link'), '');
                innerInstanceResult = innerInstanceResult.replace(shortcodeMatcher('title'), item => replacedWithLink(item, 'title', link));
                return innerInstanceResult;
            });
            return instanceResult;
        });
    }
    return result;
};
const RenderHtml = ({ html, cmsImagePrefix = true, extended = false }) => {
    let result;
    if (extended) {
        result = (0, sanitize_html_1.default)(html, {
            allowedTags: sanitize_html_1.default.defaults.allowedTags.concat(['img', 'br', 'iframe', 'blockquote']),
            allowedAttributes: {
                a: ['href', 'name', 'target'],
                img: ['src', 'alt'],
                iframe: ['src'],
            },
        });
    }
    else {
        result = (0, sanitize_html_1.default)(html);
    }
    if (cmsImagePrefix) {
        result = addImageSource(result);
    }
    result = addImageCaptions(result);
    result = addRetinaImages(result);
    result = processOfferShortcodes(result);
    result = processArticlesShortcodes(result);
    return (0, jsx_runtime_1.jsx)("div", { dangerouslySetInnerHTML: { __html: result } });
};
exports.default = RenderHtml;
